<template>

    <div class="row">
      <div class="col-12 card">
        <h4>Профиль клиента</h4>
        <h5 class="top-24">{{ currentUser.company_name[0] }} (ИНН {{ currentUser.company_inn[0] }})</h5>
        <div class="row">
          <div class="col-6 top-24">
              <div class="text-field">
                <label class="text-field__label" for="search">ФИО</label>
                <div class="text-field__icon">
                  <input class="text-field__input" type="search" name="search" id="search"  v-model="currentUser.username" disabled="True">
                </div>
              </div>
          </div>
        </div>
        <div class="row">
            <div class="col-6 top-24" >
              <div class="text-field">
                <label class="text-field__label" for="search">Электронная почта</label>
                <div class="text-field__icon">
                  <input class="text-field__input" type="search" name="search" id="search" v-model="currentUser.email" disabled="True">
                </div>
              </div>
            </div>
            <div class="col-6 top-24">
              <div class="text-field">
                <label class="text-field__label" for="search">Телефон</label>
                <div class="text-field__icon">
                  <input class="text-field__input" type="search" name="search" id="search" v-model="currentUser.phone" disabled="True">
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  
  export default {
    data() {
      return {
        title: "Профиль организации"
      }
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        }
    },
  };
  </script>